
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRainShowersMonColour as ObiRainShowersMonColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-rain-showers-mon-colour.js';
 
 
 

 
 export const ObiRainShowersMonColour = createComponent({
   react: React,
   tagName: 'obi-rain-showers-mon-colour',
   elementClass: ObiRainShowersMonColourElement,
   events: {
     
   }
  });
 
 